// removed by extract-text-webpack-plugin
module.exports = {"layout":"_31oapFpKPiuY8afXEJK92Q","content":"zZXZlxvQBh7sHspcYymHt"};


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Layout/Layout.scss
// module id = 681
// module chunks = 0